export default (data, message) => {
  if (!data) throw message
}
